<template>
  <nav class="header_menu_nav">
    <button @click="toogle" type="button" class="nav-btn" :class="{open: open}" aria-label="Toggle navigation" title="Menu">
      <span class="header-button-label">Atalhos Rápidos</span>
      <span class="header-button-arrow header-button-arrow_nav-toggle"></span>
    </button>
    <div v-if="open" class="main-menu-container">
      <ul class="main-menu">
        <nav-link :route="{name: 'leiloes.show'}" label="Resumo e Lotes" icon-type="erp" icon="metas" icon-style="regular" />
        <nav-link :route="{name: 'leiloes.tela-leiloeiro'}" label="Painel do Leiloeiro" icon-type="fa" icon="id-card" icon-style="regular" />
        <nav-link icon="tv-retro" icon-type="fa" label="Transmissão" has-submenu>
          <template v-slot:submenu>
            <transmissao-submenu />
          </template>
        </nav-link>
        <nav-link :route="{name: 'leiloes.habilitacoes'}" label="Habilitações" icon-type="erp" icon="approved" />
        <nav-link :route="{name: 'leiloes.lances.automaticos'}" label="Lances Automáticos" icon-type="fa" icon="robot" />
        <nav-link icon="user" icon-type="erp" label="Arrematante" has-submenu>
          <template v-slot:submenu>
            <arrematante-submenu />
          </template>
        </nav-link>
        <nav-link icon-type="fa" icon="business-time" label="Comitente" has-submenu>
          <template v-slot:submenu>
            <comitente-submenu />
          </template>
        </nav-link>
        <nav-link icon="contract" icon-type="erp" label="Fechamento" has-submenu>
          <template v-slot:submenu>
            <fechamento-submenu />
          </template>
        </nav-link>
        <nav-link @click.native="$router.push({name: 'leiloes.relatorios'})" icon="reports" icon-type="erp" label="Relatórios" close-on-click has-submenu>
          <template v-slot:submenu>
            <relatorios-submenu />
          </template>
        </nav-link>
      </ul>
    </div>
  </nav>
</template>

<script>
import NavLink from './NavLink'
import ArrematanteSubmenu from './ArrematanteSubmenu'
import ComitenteSubmenu from './ComitenteSubmenu'
import TransmissaoSubmenu from "@/components/leiloes/components/layout-components/TransmissaoSubmenu"
import FechamentoSubmenu from "@/components/leiloes/components/layout-components/FechamentoSubmenu"
import LeilaoMixin from "@/components/leiloes/components/LeilaoMixin"
import RelatoriosSubmenu from "@/components/leiloes/components/layout-components/RelatoriosSubmenu";
export default {
  name: 'NavBtn',
  mixins: [LeilaoMixin],
  provide: function () {
    return {
      nav: this
    }
  },
  components: {RelatoriosSubmenu, FechamentoSubmenu, TransmissaoSubmenu, ComitenteSubmenu, ArrematanteSubmenu, NavLink},
  data () {
    return {
      open: false
    }
  },
  mounted () {
    document.body.addEventListener('click', this.clickOutside, true)
  },
  beforeDestroy () {
    document.body.removeEventListener('click', this.clickOutside)
  },
  methods: {
    toogle () {
      this.open = !this.open
    },
    clickEvent ($event) {
      this.toogle()
    },
    clickOutside (evt) {
      if (
        evt && evt.target && this.$el &&
        (this.$el.contains(evt.target) || (this.$el.parentNode && this.$el.parentNode.contains(evt.target)))
      ) {
        return
      }
      this.open = false
    }
  }
}
</script>
